<template>
	<div v-if="show">
		<GChart
			type="PieChart"
			:data="chartData"
			:options="chartOptions"
			:events="chartEvents"
			ref="chart"
			@ready="onChartReady"
		/>
	</div>

</template>

<script>
	export default{
		data : function(){
			return {
				show : false,
				chartData : [],
				chartOptions : {
					pieHole: 0.4,
					height: 400,
					title : 'HHAs per Organization',
					chartArea:{width:'100%'},
					colors: ['#215052', '#11a5a7', '#ededed'],
				},
				chartEvents : {
					select : () => {
						var selection = this.chart.getSelection();

						console.log(selection);
					}
				},
				chart :null,
				is3D: true,
				
			}
		},

		created : function(){
			this.iniChart();
		},
		methods : {
			iniChart : function(){
				var params = {
					filters : {}
				}
				this.$store.dispatch('getOrganizations', params).then((res) => {
					this.organizations = res.data.data;
					
					console.log(this.organizations.length);
					
					var i = 0;
					var organizationData = [
						['Task', 'Test']
					];
					for (i=0; i<this.organizations.length;  i++){
						organizationData[i+1] = [this.organizations[i].name, this.organizations[i].n_providers];
					}

					console.log(organizationData);

					this.chartData = organizationData;
					/*
					this.chartData = [
						['Task', 'Hours per Day'],
				          ['Work',     11],
				          ['Eat',      2],
				          ['Commute',  2],
				          ['Watch TV', 2],
				          ['Sleep',    7]
					];*/


					this.show = true;
				}).catch((error) => {
					console.log(error);
				});
			},
			refresh : function(){
				this.iniChart();
			},
			onChartReady : function(chart, google){
				this.chart = chart;
			}
		}
	}
	/*
		getOrganizations : function() {
				var params = {
					filters : {
						page : this.current_page,
						per_page : this.per_page
					}
				}
				
				this.$store.dispatch('getOrganizations', params).then((res) => {
					
					this.organizations = res.data.data;

					this.current_page = res.data.meta.current_page;
					this.total_rows = res.data.meta.total;
					this.per_page = parseInt(res.data.meta.per_page);
					this.from = res.data.meta.from;
					this.to = res.data.meta.to;
				}).catch((error) => {
					console.log(error);
				});
			},
	*/
</script>


// WEBPACK FOOTER //
// src/components/charts/AdminLHCSADashboardChart1Component.vue